import { useEffect } from "react";
import { notificationsConfig } from "../config/notifications.config.js";
import { useNotificationsStore } from "../stores/use-notifications-store.js";
import { NotificationsContext } from "./notifications-context.js";

const MOUNTED_GUARD = /** @type {const} */ ({ mounted: true });

/**
 * Feature Logic: inicializa fetch + polling GET a cada 5 minutos.
 * JSX mínimo de composição (Provider + children). Único dono do setInterval.
 *
 * @param {{ children: import("react").ReactNode }} props
 */
export function NotificationsProvider({ children }) {
  const fetchNotifications = useNotificationsStore(
    (state) => state.fetchNotifications,
  );

  useEffect(() => {
    fetchNotifications();

    const intervalId = setInterval(() => {
      fetchNotifications();
    }, notificationsConfig.pollingIntervalMs);

    return () => {
      clearInterval(intervalId);
    };
  }, [fetchNotifications]);

  return (
    <NotificationsContext.Provider value={MOUNTED_GUARD}>
      {children}
    </NotificationsContext.Provider>
  );
}
